/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Report_Geography_Detail_TitleInputs */

const vi_report_geography_detail_title = /** @type {(inputs: Report_Geography_Detail_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đơn hàng theo tỉnh/thành`)
};

/**

* @param {Report_Geography_Detail_TitleInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const report_geography_detail_title = /** @type {((inputs?: Report_Geography_Detail_TitleInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Report_Geography_Detail_TitleInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_report_geography_detail_title(inputs)
});